import React, { useContext, useState, useEffect } from "react";
import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import { LoginFormContext } from "context/LoginFormContext";
import { ModalContext } from "context/ModalContext";
import { useFormik } from "formik";
import PropTypes from "prop-types";
import MDSelectBox from "components/MDSelectBox";
import { validationSchema } from "./Schemas/validation";
import { initialValues } from "./Schemas/initialValue";
import { statusData } from "helpers/constant";
import SubmitButton from "components/SubmitButton";
import MDInput from "components/MDInput";
import { TalukaContext } from "context/TalukaContext";
import { addTalukaApi } from "Apis/district";
import { updateTalukaApi } from "Apis/district";

const TalukaForm = ({ talukaData }) => {
  const { setNotification } = useContext(LoginFormContext);
  const { editData, setEditData, districtList, setDistrictList, getDistrictApi } =
    useContext(TalukaContext);
  const [district, setDistrict] = useState([]);
  const [status, setStatus] = useState({
    label: "Active",
    value: "1",
  });
  const { setOpen, formIsEdit } = useContext(ModalContext);

  const handleSubmit = async (values) => {
    if (!formIsEdit) {
      let response = await addTalukaApi(values);
      if (response?.status === 200) {
        talukaData();
        setOpen(false);
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: response.data.message,
          open: true,
        });
      }
    } else {
      let editData = await updateTalukaApi(values);
      if (editData?.status === 200) {
        setNotification({
          color: "success",
          icon: "check",
          title: "Success",
          content: editData.data.message,
          open: true,
        });
        setOpen(false);
        talukaData();
      } else {
        setNotification({
          color: "error",
          icon: "cancel",
          title: "Error",
          content: editData.data.message,
          open: true,
        });
      }
    }
  };

  const handleStatusChange = (value) => {
    if (value) {
      formik.setFieldValue("is_active", value.value);
      setStatus(value);
    } else {
      formik.setFieldValue("is_active", null);
      setStatus(null);
    }
  };

  const formik = useFormik({
    initialValues: formIsEdit ? setEditData : initialValues,
    validationSchema: validationSchema,
    onSubmit: handleSubmit,
  });

  // set data in formik
  const setDataInFormik = async () => {
    formik.setValues(editData);
  };

  const getStatusLabel = (id) => {
    const status = statusData.find((item) => item.value == id);
    return status ? status.label : "-";
  };

  const getDistrictLabel = (id) => {
    const district = districtList.find((item) => item.id === id);
    return district ? district.label : "-";
  };

  useEffect(() => {
    getDistrictApi();
    if (formIsEdit) {
      setDataInFormik();
      setStatus({ label: getStatusLabel(editData?.is_active), value: editData?.is_active });
      setDistrict(
        editData.district_id
          ? { label: getDistrictLabel(editData.district_id), value: editData.district_id }
          : null
      );
    }
  }, []);

  const handleDistrictValue = (value) => {
    if (value) {
      formik.setFieldValue("district_id", value.id);
      setDistrict(value);
    } else {
      formik.setFieldValue("district_id", null);
      setDistrict(null);
    }
  };

  return (
    <MDBox>
      <MDBox component="form" role="form" onSubmit={formik.handleSubmit}>
        <Grid container spacing={2} rowSpacing={1} columnSpacing={{ xs: 1, sm: 2, md: 3 }}>
          <Grid item xs={12} md={12} sx={{ paddingTop: "25px !important" }}>
            <MDSelectBox
              name="district_id"
              label="Select District"
              multiple={false}
              defaultValue={district}
              options={districtList}
              handleChange={(value) => handleDistrictValue(value)}
              onBlur={formik.handleBlur}
              width="100%"
              required
            />
            {formik.touched.district_id && formik.errors.district_id && (
              <MDBox
                component="p"
                sx={{ fontSize: "12px", marginLeft: "5px", color: "red", marginTop: "5px" }}
              >
                {formik.errors.district_id}
              </MDBox>
            )}
          </Grid>
          <Grid item xs={12} md={6} sx={{ paddingTop: "25px !important" }}>
            <MDInput
              type="text"
              name="name"
              value={formik.values.name}
              onChange={formik.handleChange}
              onBlur={formik.handleBlur}
              label="Taluka Name"
              sx={{ width: "100%" }}
              variant="standard"
              required
            />
            {formik.touched.name && formik.errors.name && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.name}
              </MDBox>
            )}
          </Grid>
          {/* status */}
          <Grid item xs={12} md={6} sx={{ paddingTop: "25px !important" }}>
            <MDSelectBox
              name="is_active"
              defaultValue={status}
              options={statusData}
              handleChange={(value) => handleStatusChange(value)}
              label="Status"
              width="100%"
              multiple={false}
              onBlur={formik.handleBlur}
              required
            />
            {formik.touched.is_active && formik.errors.is_active && (
              <MDBox sx={{ fontSize: "12px", color: "red", marginTop: "5px" }}>
                {formik.errors.is_active}
              </MDBox>
            )}
          </Grid>
        </Grid>
        <MDBox sx={{ width: "100%", textAlign: "center", marginTop: "20px" }}>
          <SubmitButton btnText={formIsEdit ? "Update" : "Add"} type="submit" />
        </MDBox>
      </MDBox>
    </MDBox>
  );
};
TalukaForm.propTypes = {
  talukaData: PropTypes.func,
};
export default TalukaForm;
